export const CUSTOMER_SELECT_LABEL = "Kunde";
export const CUSTOMER_SELECT_PLACEHOLDER = "Kunde auswaehlen";
export const CUSTOMER_SELECT_NO_OPTIONS = "Keine Kunden gefunden";
export const CUSTOMER_SELECT_LOADING = "Kunden werden geladen...";
export const CUSTOMER_SELECT_EMPTY_HELPER =
    "Keine Kunden vorhanden. Bitte zuerst einen Kunden anlegen.";

export const normalizeCustomerLabel = (value) =>
    typeof value === "string" ? value.trim() : "";

export const buildCustomerDisplayName = (customer) => {
    const companyName = normalizeCustomerLabel(customer?.companyName);
    const personName = normalizeCustomerLabel(
        [customer?.name, customer?.lastname].filter(Boolean).join(" ")
    );
    const email = normalizeCustomerLabel(customer?.email);
    return companyName || personName || email || "Unbenannter Kunde";
};

export const buildCustomerOptions = (customers = []) =>
    customers
        .filter(Boolean)
        .map((customer) => {
            const displayName = buildCustomerDisplayName(customer);
            const email = normalizeCustomerLabel(customer?.email);
            const label = email && email !== displayName ? `${displayName} (${email})` : displayName;
            const matchKeys = [
                displayName,
                normalizeCustomerLabel(customer?.companyName),
                normalizeCustomerLabel([customer?.name, customer?.lastname].filter(Boolean).join(" ")),
                email,
            ].filter(Boolean);
            return {
                id: customer?.id || "",
                label,
                displayName,
                matchKeys,
            };
        });

const normalizeSearchValue = (value) => normalizeCustomerLabel(value).toLowerCase();

export const findMatchingCustomerOption = (options, value) => {
    const normalized = normalizeSearchValue(value);
    if (!normalized) {
        return null;
    }
    return (
        options.find((option) =>
            option.matchKeys.some((key) => normalizeSearchValue(key) === normalized)
        ) || null
    );
};

export const resolveCustomerOption = (options, id, name) => {
    if (id) {
        const selected = options.find((option) => option.id === id);
        if (selected) {
            return selected;
        }
    }
    if (!name) {
        return null;
    }
    return findMatchingCustomerOption(options, name);
};

export const getCustomerOptionLabel = (option) =>
    option?.label || option?.displayName || "";

export const isCustomerOptionEqualToValue = (option, value) =>
    Boolean(option && value && option.id === value.id);
